import { Action } from 'redux';
import { DeskOpeningModel } from '../../../api/core/core.types';

export const GET_DESK_OPENING_LIST = 'GET_DESK_OPENING_LIST';
export const POST_DESK_OPENING = 'POST_DESK_OPENING';
export const PUT_DESK_OPENING = 'PUT_DESK_OPENING';
export const DELETE_DESK_OPENING = 'DELETE_DESK_OPENING';

export interface GetDeskOpeningListActuion extends Action {
  type: typeof GET_DESK_OPENING_LIST;
  payload: {
    deskOpenings: DeskOpeningModel[];
  };
}

export interface PostDeskOpeningAction extends Action {
  type: typeof POST_DESK_OPENING;
  payload: {
    success: boolean;
    newDeskOpening: DeskOpeningModel | null;
  };
}

export interface PutDeskOpeningAction extends Action {
  type: typeof PUT_DESK_OPENING;
  payload: {
    selectedDeskOpening: DeskOpeningModel;
  };
}

export interface DeleteDeskOpening extends Action {
  type: typeof DELETE_DESK_OPENING;
  payload: {
    success: boolean;
  };
}

export interface DeskOpeningState {
  deskOpenings: DeskOpeningModel[] | [];
  selectedDeskOpening: DeskOpeningModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
}

export type DeskOpeningActionType = GetDeskOpeningListActuion | PostDeskOpeningAction | PutDeskOpeningAction | DeleteDeskOpening;
